
import { apiVersion, dataset, projectId, studioUrl } from "./api";
import { createClient, type QueryParams } from '@sanity/client';

export const sanityClient = createClient({
    projectId,
    dataset,
    apiVersion,
    token: process.env.SANITY_VIEWER_TOKEN,
    stega: {
        studioUrl,
    },
    useCdn: true,
});

const revalidate = 60;

export async function sanityFetch<const QueryString extends string>({
    query,
    params = {},
    isEnabled = false,
}: {
    query: QueryString
    params?: QueryParams
    isEnabled?: boolean
}) {
    return sanityClient.fetch(query, params, {
        next: {
            revalidate: isEnabled ? 0 : undefined,
        },
        ...isEnabled ? {
            perspective: "drafts",
            useCdn: false,
            stega: true,
        } : undefined
    })
}